import React from 'react';

import { Search } from 'lucide-react';

import { RequestCompanyDialog } from '..';

const CompaniesNotFound = () => {
    return (
        <div className='flex items-center justify-center w-screen h-[calc(100dvh-400px)] bg-white text-gray-600'>
            <div className='flex flex-col items-center justify-center text-center px-4 py-6 gap-3'>
                <Search className='w-10 h-10 p-2 bg-gray200 rounded-full text-textPrimary' />
                <div className='text-sm font-semibold text-gray800'>Not Found!</div>
                <div className='text-xs text-gray-500'>
                    There is no result for your search. Would you like to add this to
                    <span className='font-semibold'> THE LIST</span>?
                </div>

                <div className='flex flex-col gap-4 text-xs text-gray-500 space-y-2'>
                    <RequestCompanyDialog />
                </div>
            </div>
        </div>
    );
};

export { CompaniesNotFound };
